import { CONTACT_STANDARD_FIELD_IDS } from "components/Event/Contacts/constants";
import { pathOr } from "ramda";

const { fname, email, lname } = CONTACT_STANDARD_FIELD_IDS;
const getValue = pathOr("");

export const getContactEmail = getValue([email]);
export const getContactLastName = getValue([lname]);
export const getContactFirstName = getValue([fname]);
